export default () => navigator.userAgent.toLowerCase().indexOf("firefox") > -1
